<button 
  class="feedback-button" 
  (click)="openFeedbackModal()"
  title="Feedback geben">
  <i class="bi bi-chat-dots-fill"></i>
  <span class="feedback-text">Feedback</span>
</button>

